export const commonConstants = {
  COMMON_SET_SUBMENU: 'COMMON_SET_SUBMENU',
  COMMON_SET_MODULE: 'COMMON_SET_MODULE',
  COMMON_SET_ACCORDION: 'COMMON_SET_ACCORDION',
};